<template>
  <li class="list-group-item d-flex align-items-center small">
    <span class="mr-3">
      <i
        ref="primaryIcon"
        style="cursor: pointer;"
        :title="isPrimary ? 'Select as primary CV' : 'Deselect as primary CV'"
        @click="setAsPrimary"
        :class="isPrimary ? 'fas fa-crown crown-active' : 'fas fa-crown'"
      ></i>
    </span>

    <span class="mr-auto">{{ file.file.name }}</span>
    <span class="badge badge-primary badge-pill ml-auto">{{
      `${(file.file.size / 1024 / 1024).toFixed(2)} MB`
    }}</span>
    <span class="remove-container ml-4">
      <span class="close" style="cursor: pointer" @click="removeFile">&times;</span>
    </span>
  </li>
</template>
<script>
export default {
  data: () => ({
    isPrimary: false,
  }),
  props: {
    file: Object,
    index: Number,
  },
  watch: {
    // Watcher for the 'file' prop
    file: {
      handler(newVal, oldVal) {
        this.isPrimary = newVal.isPrimary;
      },
      deep: true, // This ensures that changes in the object's properties are also watched
      immediate: true, // This will trigger the handler immediately with the current value on mount
    },
  },
  methods: {
    setAsPrimary() {
      this.$emit('setPrimary', this.index);
    },
    removeFile() {
      this.$emit('deleteDoc', this.index);
    },
  },
};
</script>
<style lang="scss" scoped>
.crown-active {
  color: #f05a00 !important;
}
</style>
